import { anatomyModule } from "./anatomy";
import { histologyModule } from "./histology";
import { physiologyModule } from "./physiology";

export const liverModules = [anatomyModule, histologyModule, physiologyModule];
